module.exports = __webpack_public_path__ + "img/ranking_crown.61fc0a62.svg";